export function isNullOrUndefined(input) {
    return (input == null);
}
export function nullWhenEmptyOrUndefined(input) {
    if (isNullOrUndefined(input))
        return null;
    if (input.length === 0)
        return null;
    return input;
}
export function fileSizeKBToMB(maxFileSize) {
    if (isNullOrUndefined(maxFileSize))
        return null;
    return Math.floor(maxFileSize / 1024);
}
export function fileSizeBToMB(maxFileSize) {
    if (isNullOrUndefined(maxFileSize))
        return null;
    return Math.round(((maxFileSize / 1024) / 1024) * 10) / 10;
}
export function getSuccessNotificationOptions(groupName, action) {
    return {
        type: 'success',
        group: groupName,
        title: "Success",
        text: action,
    };
}
export function getWarningNotificationOptions(groupName, action) {
    return {
        type: 'warn',
        group: groupName,
        title: "Toggle",
        text: action,
    };
}
export function getErrorNotificationOptions(groupName, action) {
    return {
        type: 'error',
        group: groupName,
        title: "Error",
        text: action,
    };
}
export function getErrorNotificationWithErrorsOptions(groupName, errors) {
    var errorsString = "";
    for (var i = 0; i < errors.length; i++) {
        if (i != 0)
            errorsString += "\n";
        errorsString += errors[i];
    }
    return {
        type: 'error',
        group: groupName,
        title: "Error",
        text: errorsString,
        duration: 10000,
    };
}
export function getWarningsNotificationOptions(groupName, warnings) {
    var warningText = "";
    for (var i = 0; i < warnings.length; i++) {
        if (i != 0)
            warningText += "\n";
        warningText += warnings[i];
    }
    return {
        type: 'warn',
        group: groupName,
        title: "Warning",
        text: warningText,
        duration: 30000,
    };
}
